<template>
    <div style="width: 100%;height: 100%;">
        <div style="width: 100%;">
            <LayoutHeader />
            <div class="breadBox">
                <div class="child">
                    <a-breadcrumb>
            <span>
              当前位置：
            </span>
                        <a-breadcrumb-item style="cursor: pointer;" @click="this.$router.push('/')">首页
                        </a-breadcrumb-item>
                        <a-breadcrumb-item style="cursor: pointer;" @click="this.$router.push('/projectReview')">信息化项目评审</a-breadcrumb-item>
                        <a-breadcrumb-item>信息化项目评审详情</a-breadcrumb-item>
                    </a-breadcrumb>
                </div>
            </div>
            <div style="width: 100%;margin-top: 1%;">
                <div class="banner-box">
<!--                    <div class="box"></div>-->
<!--                    <img src="@/assets/home/pingshen-detai-banner.png" alt="">-->
                    <div class="text-box">
                        <div class="text2">{{ dataSource.projectReviewName }}</div>
                        <div class="info-box">
                            <div class="info">
                                <div class="info-text">
                                    <img src="../assets/home/ps-detail-icon2.png" alt="">
                                    <span class="detail-title">评审地点：</span><span
                                   >{{ dataSource.reviewPlace }}</span>
                                </div>
                                <div class="info-text">
                                    <img src="../assets/home/ps-detail-icon1.png" alt="">
                                    <span class="detail-title">评审时间：</span><span
                                   >{{ dataSource.reviewTime }}</span>
                                </div>
                                <div class="info-text">
                                    <img src="../assets/home/ps-detail-icon3.png" alt="">
                                    <span class="detail-title">报名人数：</span><span><span
                                    >{{
                                        getRegisterCount(dataSource)
                                    }}</span> / {{ dataSource.reviewExpertCount }}</span>
                                </div>
                                <div class="info-text" v-if="dataSource.registerStartTime">
                                    <img src="@/assets/home/ps-detail-icon4.png" alt="">
                                    <span class="detail-title">报名开始时间：</span>
                                    <span>
                                        <span>{{
                                                dataSource.registerStartTime
                                            }}</span>
                                    </span>
                                </div>
                            </div>
                            <a-button type="default" shape="round" size="large" disabled
                                      class="a-button-self"
                                      style="background-image: linear-gradient(180deg, #329dff, #006acc);"
                                      v-if="isNoStart">
                                未开始
                            </a-button>

                            <a-button type="default" shape="round" size="large" disabled
                                      class="a-button-self"
                                      style="background-image: linear-gradient(180deg, #999999, #666666);"
                                      v-else-if="isInvalid">
                                已作废
                            </a-button>

                            <a-button type="default" shape="round" size="large" disabled
                                      class="a-button-self"
                                      style="background-image: linear-gradient(180deg, #999999, #666666);"
                                      v-else-if="isOver">
                                已结束
                            </a-button>

                            <a-button type="default" shape="round" size="large" disabled
                                      v-else-if="isReg"
                                      class="a-button-self"
                                      style="background-image: linear-gradient(180deg, #ffad50, #ff8c46);">
                                已报名
                            </a-button>
                            <a-button type="default" shape="round" size="large" disabled
                                      v-else-if="isRegisteredMax"
                                      class="a-button-self"
                                      style="background-image: linear-gradient(180deg, #5c80c5, #3c5582);">
                                报名人数已满
                            </a-button>

                            <a-button type="default" shape="round" size="large"
                                      class="a-button-self"
                                      style="background-image: linear-gradient(180deg, #329dff, #006acc);"
                                      v-else-if="isRegistering"
                                      @click="onRegister">
                                我要报名
                            </a-button>
                        </div>
                        </div>
                    </div>
                </div>
                <div class="list-container">
                    <div class="tab-box">
                        <div class="tab" :class="tabsId == '#first' ? 'item-active':''" @click="tabsClick('#first')">
                            评审要求
                            <img v-if="tabsId == '#first'" src="../assets/home/sanjiao.png" alt="">
                        </div>
                        <div class="tab" :class="tabsId == '#second' ? 'item-active':''" @click="tabsClick('#second')">项目概述
                            <img v-if="tabsId == '#second'" src="../assets/home/sanjiao.png" alt=""></div>
                        <div class="tab" :class="tabsId == '#three' ? 'item-active':''" @click="tabsClick('#three')">评审报酬
                            <img v-if="tabsId == '#three'" src="../assets/home/sanjiao.png" alt=""></div>
                    </div>
                    <div style="width: 90%;">
                        <div class="project-content" ref="first">
                            <div class="title">
                                <img src="../assets/img/pingshen-detail-title-icon.png" alt="">
                                报名专家要求
                            </div>
                            <div class="content">
                                <div v-for="item in dataSource.ratioList" :key="item.id">{{item.groupName}}：{{isNoStart?0:item.groupRegCount||0}}/{{item.groupCount}}</div>
                                <div v-if="hasAny.hasAny">
                                    不限：{{isNoStart?0:hasAny.regSy||0}}/{{hasAny.remaining}}
                                </div>
<!--                                <div v-if="dataSource.ratioList.length===0">
                                    无要求
                                </div>-->
                            </div>
                        </div>
                        <div class="project-content" ref="first">
                            <div class="title">
                                <img src="../assets/img/pingshen-detail-title-icon.png" alt="">
                                评审要求
                            </div>
                            <div class="content" v-text="dataSource.reviewDemand"></div>
                        </div>
                        <div class="project-content" ref="second">
                            <div class="title">
                                <img src="../assets/img/pingshen-detail-icon1.png" alt="">
                                项目概述</div>
                            <div class="content" v-text="dataSource.projectOverview"></div>
                        </div>
                        <div class="project-content" ref="three">
                            <div class="title">
                                <img src="../assets/img/pingshen-detail-icon2.png" alt="">
                                评审报酬</div>
                            <div class="content2">
                                <div @click="exportExcelTemplate(4)">
                                    <img style="margin-right: 8px" src="../assets/img/pdf.png" alt="">
                                    <a href="#">山西省财政厅关于印发政府采购评审专家劳务报酬支付标准暂行规定的通知.pdf</a>
                                </div>
                                <div @click="exportExcelTemplate(5)">
                                    <img style="margin-right: 8px" src="../assets/img/pdf.png" alt="">
                                    <a href="#">关于规范自然人劳务费增值税发票开具工作的通知.pdf</a>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
        <LayoutFooter/>
        <a-modal title="信息确认" :visible="modal.visible" centered :destroy-on-close="true" :mask-closable="false"
                 :confirm-loading="modal.confirmLoading" @cancel="()=>{modal.visible=false}" width="40%">
            <a-descriptions title="" :column="1">
                <a-descriptions-item label="姓名">{{ expertInfo.name }}</a-descriptions-item>
                <a-descriptions-item label="手机号">{{ expertInfo.phoneNumber }}</a-descriptions-item>
                <a-descriptions-item label="身份证号">{{ expertInfo.idCard }}</a-descriptions-item>
                <a-descriptions-item label="工作单位">{{ expertInfo.workUnit }}</a-descriptions-item>
                <a-descriptions-item label="职称">{{ expertInfo.positional }}</a-descriptions-item>
                <a-descriptions-item label="银行卡号">{{ expertInfo.bankAccount }}</a-descriptions-item>
            </a-descriptions>
            <a-alert v-if="!expertInfo.bankAccount" message="未填写银行卡信息" type="warning" show-icon />
            <a-alert v-if="(expertInfo.appointmentFlag||'0')!=='1'" message="未颁发聘书" type="warning" show-icon />
            <template #footer>
                <a-button key="back" @click="()=>{modal.visible=false}">取消</a-button>
                <a-button :disabled="regBtnFlag" key="submit" type="primary" @click="register">报名</a-button>
            </template>
        </a-modal>
    </div>
</template>

<script>
import {dictMixin} from "@/mixins";
import {login_mp} from "@/api/adminService";
import {ls} from "@/utils/util"
import {enterpriseOperatingIncome} from "@/api/integral";
import {sys_admin, file_service, noticeInfoHome} from "@/api/adminService";
import {noticeInfo, getBannerInfo, getWebInfo} from "@/api/homeService";
import {platformName} from "@/config/platformConfig";
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2';
import LayoutHeader from '@/layout/layoutPage/header/LayoutHeaderNew2';
import {getDistMixin, listMixin} from "@/mixins";
import {applicationIndex, registered} from "@/api/projectReviewService"

import axios from "axios";
import moment from "moment";


export default {
    name: "index",
    components: {
        LayoutFooter,
        LayoutHeader
    },
    mixins: [dictMixin, getDistMixin, listMixin],
    data() {
        return {
            regBtnFlag:false,
            tabsId:'#first',
            isReg:false,
            reviewId:"",
            expertInfo:{},
            modal:{
                visible:false,
                confirmLoading: false
            },
            noticeData: [],
            scrollNoticeData: [],
            fourObj: {},
            user: {},
            getDetailNoteParam: null,
            operatingIncomeScale: null,
            platformName,
            getAuditStatus: null,
            visible: false,
            getDateId: null,
            formState: {
                user: undefined,
            },
            policyNotice: {},
            bannerData: [],
            webSiteInfo: {},
            linkData: [],
            queryParam: {},
            current: 1,
            pageSize: 10,
            str: null,
        }
    },
    computed: {
        listUrl() {
            return applicationIndex.notLoginDetail
        },
        isInvalid(){
            return this.dataSource.reviewStatus==='-1'
        },
        canDo(){
            return this.dataSource.reviewStatus==='3'
        },
        isNoStart(){
            return this.canDo && moment(this.dataSource.registerStartTime).isAfter(moment.now())
        },
        isRegistering(){
            const now = moment();
            const after = now.isAfter(moment(this.dataSource.registerStartTime));
            // const before = now.isBefore(moment(this.dataSource.registerEndTime));
            return this.canDo
                && after
                // && before
                && this.isNoReview;
        },
        isRegisteredMax(){
            const max = (this.dataSource.registeredCount||0)===(this.dataSource.reviewExpertCount||0);
            return this.isRegistering && max;
        },
        isEnd(){
            return this.canDo
                && moment(this.dataSource.registerEndTime).isBefore(moment.now())
                && this.isNoReview
        },
        isNoReview(){
            const now = moment();
            return this.canDo && moment(this.dataSource.reviewTime).isAfter(now);
        },
        isOver(){
            const now = moment();
            const status = this.dataSource.reviewStatus==='0' || this.dataSource.reviewStatus>='4';
            return moment(this.dataSource.reviewTime).isBefore(now) || status;
        },
        hasAny(){
            let all = 0;
            let reg = 0;
            for (let ratio of this.dataSource.ratioList) {
                all+=ratio.groupCount;
                reg+=ratio.groupRegCount
            }
            let sy = this.dataSource.reviewExpertCount - all;
            let regSy = this.dataSource.registeredCount - reg;

            return{
                hasAny: sy>0,
                remaining: sy,
                regSy:regSy
            }
        }
    },
    methods: {
        download(id){
            const link = document.createElement("a"); // 创建a标签
            link.href = file_service.download + id;
            link.download = "关于规范自然人劳务费增值税发票开具工作的通知.pdf";
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        getRegisterCount(dataSource){
            if (this.isNoStart){
                return 0
            }
            return dataSource.registeredCount || 0
        },
        tabsClick(anchor){
            const element = this.$refs[anchor.slice(1)];
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
            this.tabsId = anchor
        },
        exportExcelTemplate(type) {
            axios({
                method: 'post',
                url: applicationIndex.download,
                responseType: 'blob',
                params: {type:type}
            }).then(data => {
                // this.spinShow = false
                const blob = new Blob([data.data], {type: "application/excel"});
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a"); // 创建a标签
                link.href = url;
                if(type==4){
                    link.download = decodeURIComponent('山西省财政厅关于印发政府采购评审专家劳务报酬支付标准暂行规定的通知.pdf');// 文件重命名，若无需重命名，将该行删去
                }else{
                    link.download = decodeURIComponent('关于规范自然人劳务费增值税发票开具工作的通知.pdf');// 文件重命名，若无需重命名，将该行删去
                }
                link.click();
                URL.revokeObjectURL(url); // 释放内存
            })
        },
        onChange(e) {
            this.params.pageNum = e
        },
        logout() {
            let self = this;

            self.$ls.clear();
            self.$store.commit('setMenuData', []);
            self.$router.replace('/');

            location.reload();
        },
        onLogout() {
            let self = this;
            self.$confirm({
                title: '确认要退出登录?',
                content: '',
                onOk() {
                    self.postAction({
                        url: login_mp.saveLog,
                        params: {logAppCategoryEnum: "LOGOUT"}
                    }).then(res => {
                        console.log(res)
                        self.getAction({
                            url: login_mp.logout,
                            params: {access_token: ls.get("token") || ""},
                            isValid: false
                        }).then(() => {
                            self.$notification['success']({
                                message: '退出成功',
                                style: {
                                    fontWeight: '600',
                                },
                            });
                        })
                    })


                    setTimeout(() => {
                        self.logout();
                    }, 2000)
                },
                onCancel() {
                },
            });
        },
        goMorePolicy() {
            this.$router.push({
                path: '/notice',
                // query: { type: "资讯公告", activeKey: 2 }
            })
        },
        goDetail(id, type) {
            this.$router.push({
                path: "/noticeDetail",
                query: {id: id, type: type}
            })
        },
        getUserInfo() {
            this.getAction({
                url: sys_admin.userInfor
            }).then(res => {
                sessionStorage.setItem("roleCode", res.roleCode.split(','));
            })
        },
        getNoticeInfo() {
            this.getAction({
                url: noticeInfo.pageList,
                params: {pageNum: 1, pageSize: 10}
            }).then(res => {
                this.noticeData = res.records
            })
        },
        getNoticeDownInfo() {
            this.getAction({
                url: noticeInfoHome.pageList,
                params: {pageNum: 1, pageSize: 10}
            }).then(res => {
                this.scrollNoticeData = res.records
            })
        },
        goHttp(url) {
            window.open(url, '_bank')
        },
        goMore(url, str) {
            this.$router.push({path: url, query: {id: str}})
        },
        goMoreNotice(url, str) {
            console.log('url: ', url, str)
            this.$router.push({path: url, query: {...str}})
        },
        getDetail() {
            this.getAction({
                url: enterpriseOperatingIncome.detail,
                params: {
                    id: this.getDateId.id,
                },
                returnMsg: true,
            }).then((res) => {
                this.getDetailNoteParam = res.data
                this.operatingIncomeScale = res.data.operatingIncomeScale
                this.getAuditStatus = res.data.auditStatus
            });
        },
        getDate() {
            this.getAction({
                url: enterpriseOperatingIncome.getDate,
                // params: { id: id },
                returnMsg: true,
            }).then((res) => {
                this.getDateId = res.data
                // auditStatus
            });
        },
        islogin() {
            if (ls.get('token') && ls.get("refresh_token")) {
        if (ls.get("roleCode").includes('company')) {
          this.goMore('/sys/companyInfo')
        } else if (ls.get("roleCode").includes('technicalManager')) {
          this.goMore('/sys/technology/person');
        } else if (ls.get("roleCode").includes('serviceOrganization')) {
          this.goMore('/sys/innovation/organization/index');
        } else if (ls.get("roleCode").includes('investorManager')) {
          this.goMore('/finance/investorInformation');
        } else if (ls.get("roleCode").includes('investmentMechanism')) {
          this.goMore('/finance/investmentOrganizationInformation');
        } else if (ls.get("roleCode").includes('financialAdviser')) {
          this.goMore('/finance/financialAdvisorInformation');
        } else if(ls.get("roleCode").includes('expert')){
            this.goMore('/sys/expertInfo');
        } else if(ls.get("roleCode").includes('gov-institution')){
            this.goMore("/sys/govInstitution")
        }else {
          this.goMore('/sys/userInfo')
        }
            } else {
                this.goMore('/login', 'user')
            }
        },
        getBannerList() {
            this.getAction({
                url: getBannerInfo.pageList,
                params: {type: 'home'}
            }).then(res => {
                this.bannerData = res.records.reverse()
            })
        },
        getImg(imgUrl) {
            return file_service.imagesWeb(imgUrl)
        },
        getWebInfo() {
            this.getAction({
                url: getWebInfo.detail,
                params: {id: 1}
            }).then(res => {
                this.webSiteInfo = res
            })
        },
        // todo 注册
        onRegister() {
            if (this.dataSource.reviewStatus>'4'||(this.dataSource.registeredCount||0)>=(this.dataSource.reviewExpertCount||0)){
                return
            }
            let token = ls.get("token");
            let refreshToken = ls.get("refresh_token");
            if (!token && !refreshToken){
                window.location.href='http://'+window.location.host+'/login?id=user&type=review&redirect=/projectReviewDetail?id='+this.reviewId
            }
            this.getAction({
                url: registered.checkRole,
                params: {}
            }).then(resp=>{
                if (resp){
                    this.expertInfo = resp
                    this.modal.visible = true
                }else{
                    this.$message.warning("您当前不能报名, 请使用专家角色报名");
                }
            })
        },
        register(){
            this.regBtnFlag = true
            const loading = this.$message.loading({
                content: '正在报名中...',
                duration: 0
            });
            this.postAction({
                url: registered.reg,
                params: {reviewId: this.reviewId}
            }).then(resp=>{
                if (resp){
                    this.$notification.success({
                        message: '提示',
                        description: '报名成功',
                    });
                    this.modal.visible = false
                    this.loadData()
                    this.checkIsReg()
                }else{
                    this.$message.warning("报名失败");
                }
            }).finally(()=>{
                loading()
                this.regBtnFlag = false
            })
        },
        loadData() {
            if (!this.listUrl) {
                this.$message.error("请设置listUrl属性!");
                return
            }
            let params = {
                id: this.$route.query.id
            };
            //清空选择项
            this.getAction({ url: this.listUrl, params: params }).then((data) => {
                this.dataSource = data;
            }).catch(() => {

            })
        },
        checkIsReg(){
            this.getAction({
                url: registered.isReg,
                params:{
                    reviewId: this.reviewId,
                }
            }).then(resp=>{
                this.isReg = resp
            })
        },
        getUserInfor() {
            this.getAction({
                url: sys_admin.userInfor
            }).then(res => {
                this.$ls.set("userInfo", res.userName)
                this.$ls.set("companyCode", res.companyCode)
                this.$ls.set("companyName", res.companyName)
                this.$ls.set("phoneNumber", res.phoneNumber)
                this.$ls.set("notificationId", res.id)
                this.$ls.set("roleCode", res.roleCode)
                this.$ls.set("serviceOrganizationId", res.serviceOrganizationId)

                this.user = res
                this.$ls.set('userName', res.userName, 1000 * 60 * 60 * 5);

                this.user.userName = this.$ls.get('userName')
                this.user.phoneNumber = this.$ls.get('phoneNumber')
            })
        },
        goJump(url){
            this.$router.push(url)
        }
    },
    mounted() {
        this.reviewId = this.$route.query.id

        if (ls.get('token') && ls.get("refresh_token")) {
            this.getUserInfor()
            this.checkIsReg()
        }
        this.getWebInfo()
    },
}
</script>

<style scoped lang="less">
.banner-box {
    //position: relative;


    //.box {
    //    width: 1200px;
    //    height: 245px;
    //    display: block;
    //    margin:0 auto;
    //    background: #fff;
    //    border-radius: 4px;
    //}

    .text-box {
        //position: absolute;
        //top: 0;
        width: 1200px;
        display: flex;
        flex-wrap: wrap;
        padding:30px 40px;
        margin:0 auto;
        background: #fff;
        border-radius: 4px;
        //left:50%;
        //transform: translateX(-50%);
        .info-box{
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            width: 100%;
            .info{
                width: 100%;
                .info-text{
                    color:#000;
                    font-size: 16px;
                    margin-bottom:6px;
                    display: flex;
                    .detail-title{
                        color:#9f9f9f;
                    }
                    img{
                        width: 15px;
                        height: 15px;
                        margin:3px 10px 0 0;
                    }
                }
            }
        }

        .text2 {
            font-weight: 400;
            font-size: 30px;
            color: #333;
            line-height: 50px;
            margin: 0 0 15px 0;
            width: 100%;
        }

        .button {
            background: linear-gradient(90deg, #FF8F14, #FF5C0A);
            box-shadow: 0px 0px 1px 0px #FFFFFF;
            border-radius: 4px;
            color: #fff;
            width: 160px;
            height: 44px;
            text-align: center;
            line-height: 44px;
            font-size: 20px;
            cursor: pointer;
        }
    }
}
.breadBox {
    width: 100% !important;
    padding:0 !important;
    border-bottom: 1px solid #DEDEDE;

    .child {
        width: 1200px;
        margin: 0 auto;
        padding:20px 0;

    }
}
.list-container {
    width: 1200px;
    margin:30px auto 0 auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .tab-box{
        .tab{
            cursor: pointer;
            font-size: 16px;
            color: #666666;
            margin-bottom: 20px;
            img{
                margin-bottom: 2px;
            }
        }
        .item-active{
            font-weight: bold;
            font-size: 20px;
            color: #FF8016;
        }
    }
}

.project-content {
    width: 100%;
    margin:0  0 20px 0;
    background: #fff;
    padding:20px 30px;

    .title {
        font-size: 18px;
        position: relative;
        z-index: 1;
        color: #000;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #f3f3f3;
        font-weight: bold;
        padding:0 0 15px 0;
        img{
            width: 24px;
            height: 25px;
            margin:0 10px 3px 0;
        }
    }

    .content {
        text-indent: 2em;
        line-height: 30px;
        font-size: 15px;
        padding-top:20px;
    }
    .content2 {
        line-height: 30px;
        font-size: 15px;
        padding-top:20px;
    }
}

:deep(.ant-btn) {
    color: #fc550b;
    font-weight: 600;
    padding: 0 10px;

    img {
        margin-right: 5px
    }

    &:hover {
        border-color: #ffffff;
        box-shadow: 1px 1px 5px 1px #a7a7a7;
    }
}
.headerBox {
    width: 100%;
    height: 92px;
    background-color: #fff;

    .hearderContentBox {
        width: 1200px;
        margin: 0 auto;

        .titleBox {
            cursor: pointer;
            overflow: hidden;
            float: left;
            line-height: 92px;
            font-size: 30px;
            font-weight: bold;

            .logoBox {
                float: left;
                width: 73px;
                height: 66px;
                margin-right: 5px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .rightBox {
            float: right;
            display: flex;
            justify-content: space-around;
            line-height: 92px;
            font-size: 16px;

            a {
                font-weight: 600;
            }

            .loginBox {
                // float: left;
                cursor: pointer;
            }

            .loginBox:hover {
                color: #fc550b;
            }

            .lineBox {
                height: 18px;
                top: 36px;
            }

            .resigierBox {
                cursor: pointer;
                // float: left;
            }

            .resigierBox:hover {
                color: #fc550b;
            }
        }
    }
}

.bannerBox {
    position: relative;
    width: 100%;

    :deep(.ant-carousel) {
        position: relative;
        width: 100%;
    }

    .bannerImg {
        width: 100%;
        height: 282px;

        img {
            width: 100%;
            object-fit: cover;
            height: 280px;
        }
    }
}


.cardBox {
    display: flex;
    justify-content: space-between;
    width: 1200px;
    height: auto;
    margin: 0 auto;
    // background-color: #fff;

    .smallCardBox {
        margin: 36px auto;
        height: 46px;

        .leftImg {
            float: left;
            width: 46px;
            height: 46px;
            border-radius: 50%;
        }

        .rightText {
            float: left;
            margin-left: 5px;
            line-height: 46px;

            span {
                font-size: 24px;
                color: #0048c4;
            }
        }
    }
}

.contentBox {
    margin: 0 auto 20px auto;
    width: 1200px;
    height: auto;

    .menuBox {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;

        .smallMenuBox {
            position: relative;
            padding: 24px;
            width: 19%;
            // height: 180px;
            background-color: #fff;
            cursor: pointer;
            border: 1px solid #e1f1fe;

            .menuImg {
                position: absolute;
                bottom: 10px;
                right: 6px;
            }

            .menuTitle {
                margin-bottom: 22px;
                font-size: 20px;
                font-weight: bold;
            }

            .titleInfo {
                width: 90%;
                font-size: 14px;
                color: #666;
                z-index: 11;
                position: relative;
            }

            .showMoreBtn {
                margin-top: 15px;
                background-color: #fff;
                width: 44%;
                height: 40px;
                line-height: 40px;
                text-align: center;
                opacity: 0;
            }
        }

        .smallMenuBox:hover {
            background-color: #0a2c83;
            color: #fff;
            border: none;
            -webkit-transition: all 0.3s ease 0s;
            transition: all 0.3s ease 0s;
            //border: 1px solid #ffffff;
            cursor: pointer;
            -webkit-box-shadow: 0 5px 10px 1px #d2e6ff;
            box-shadow: 0 5px 10px 1px #d2e6ff;

            .titleInfo {
                color: #fff;
            }

            .showMoreBtn {
                opacity: 1;
            }
        }
    }
}

.pointsBox {
    width: 1200px;
    margin: 0 auto;
    padding: 0 0 55px 0;

    .recruitmentContentBox {
        padding: 14px 0;
        width: 100%;

        .moreList {
            float: right;
            margin-top: -21px;
            font-size: 14px;
            color: #999;
        }

        .moreList:hover {
            color: #0a2c83;
            cursor: pointer;
        }

        .listBox {
            position: relative;
            overflow: hidden;
            padding: 10px 0;
            cursor: pointer;
            border-bottom: 1px solid #dedede;

            .leftBox {
                float: left;
                width: 150px;
                height: 80px;
                text-align: center;
            }

            .right {
                float: left;
                margin-left: 2%;
                width: 74%;
                font-size: 14px;

                .title {
                    padding: 10px 0;
                    font-size: 20px;
                    color: #333;
                    font-weight: 500;
                }

                .content {
                    overflow: hidden;
                    margin: 10px 0;
                    color: #666;
                    text-overflow: ellipsis;
                    -o-text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
            }
        }
    }

    .pagination {
        text-align: center;
        margin-bottom: 20px;
    }
}

.linkBig {
    width: 100%;
    background-color: #fff;

    .linkBox {
        overflow: hidden;
        font-size: 16px;
        color: #333;
        width: 1200px;
        margin: 0 auto;
        padding: 20px 0;


        .leftLabel {
            float: left;
            width: 7%;
            font-weight: bold;
        }

        .rightBox {
            float: left;
            margin-left: 15px;
            width: 90%;
            // display: flex;
            // justify-items: start;
            // flex-wrap: wrap;

            .itemLink {
                float: left;
                margin-right: 30px;
                margin-bottom: 5px;
                color: #333;
                // text-decoration: underline;
            }

            .itemLink:hover {
                color: #0a2c83;
            }
        }
    }
}

.footerBox {
    width: 100%;
    background-color: #333333;

    .footerContent {
        position: relative;
        margin: 0 auto;
        padding: 24px 0;
        width: 1200px;

        .firstLine {
            padding: 8px 0;
            font-size: 14px;
            color: #999;

            span {
                margin-right: 18px;
            }
        }

        .footCode {
            position: absolute;
            right: 0;
            bottom: 12%;
            text-align: center;

            .footEwm {
                margin-bottom: 8px;
            }

            .footEwmTitle {
                color: #999;
            }
        }
    }
}
:deep(.ant-list-lg .ant-list-item) {
    padding: 16px 8px;
}
.a-button-self{
    width: 160px;
    height: 44px;
    color: white;
    margin:0;
    font-size: 20px;
    border: none;
    border-radius: 4px;
}
</style>
